import a1 from "./assets/a1.jpeg";
import a2 from "./assets/a2.jpeg";
import a3 from "./assets/a3.jpeg";

export const data = [
  {
    id: 1,
    image: a1,
    theme: { background: "hsl(324, 43%, 85%)" },
  },
  {
    id: 2,
    image: a2,
    theme: { background: "hsl(207, 71%, 88%)" },
  },
  {
    id: 3,
    image: a3,
    theme: { background: "hsl(357, 62%, 52%)" },
  },
];
